export const UPDATE_SIGNUP_METADATA_MUTATION = `
  mutation UpdateSignupMetadataMutation($input: String!) {
    me {
      updateSignupMetadata(meta: $input)
    }
  }
`;
